import { clearAllLastKnownEntitlementUiKeys } from '@/services/entitlementUiCache';
import { clearItineraryAttachmentCacheDir } from '@/services/itineraryAttachments';
import { clearAllOfflineDocuments } from '@/services/offlineDocuments';
import {
  clearCachedPlacesStorageKeys,
  deleteAllOfflineMaps,
} from '@/services/offlineMaps';
import { offlineManager } from '@/services/offlineManager';
import { clearSafetyOfflineSessionData } from '@/services/offlineSafety';
import {
  clearOfflineReceiptsDir,
  clearTripPackAutocacheDisabledStorage,
} from '@/services/offlineTrips';
import { clearAllPersistedMapPinsKeys } from '@/utils/geocodeCache';

/**
 * Best-effort wipe of user-scoped offline caches when auth signs out.
 * Must not throw; failures are isolated via allSettled.
 */
export async function clearOfflineCachesOnSignOut(): Promise<void> {
  const tasks: Promise<unknown>[] = [
    clearAllLastKnownEntitlementUiKeys(),
    offlineManager.clearAllOfflineData(),
    clearAllOfflineDocuments(),
    deleteAllOfflineMaps(),
    clearCachedPlacesStorageKeys(),
    clearSafetyOfflineSessionData(),
    clearItineraryAttachmentCacheDir(),
    clearOfflineReceiptsDir(),
    clearTripPackAutocacheDisabledStorage(),
    clearAllPersistedMapPinsKeys(),
  ];

  const results = await Promise.allSettled(tasks);
  for (const r of results) {
    if (r.status === 'rejected' && __DEV__) {
      console.warn('[OfflineSessionCleanup] Step failed', r.reason);
    }
  }
}
